import styled from 'styled-components';

export const AdHocSliderStyles = styled.div`
  width: 100%;
  margin-top: 100px !important;

  @media (max-width: 991px) {
    margin-top: 50px !important;
  }

  .sliderWrapper {
    margin-top: 50px;
  }

  .texts {
    max-width: 770px;
    width: 100%;
    align-self: flex-end;
    display: flex;
    flex-direction: column;
    gap: 15px;

    h1 {
      color: #fff;
      font-size: 40px;
      font-weight: 700;
      line-height: 115%;

      @media (max-width: 768px) {
        font-size: 24px;
      }
    }
  }

  .slide {
    max-width: 770px;
    height: 550px;
    width: 100%;
    position: relative;
    background: #fff;
    flex-shrink: 0;
    border-radius: 10px;

    @media (max-width: 768px) {
      max-width: 320px;
      height: 450px;
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 2;
      background: linear-gradient(180deg, #FCC666 30%, #FA1A2E 50%, #5CB7F1 70%);
      border-radius: 10px;
      padding: 3px;
      -webkit-mask: 
        linear-gradient(#fff 0 0) content-box, 
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
  }

    &-img {
      height: 50%;
      position: relative;
      overflow: hidden;

      border-radius: 10px 10px 0 0;

      @media (max-width: 768px) {
        height: 30%;
      }

      &::before {
        position: absolute;
        content: "";
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        z-index: 2;
        background: linear-gradient(180deg, rgba(252, 198, 102, 0.24) 0%, rgba(250, 26, 46, 0.70) 100%);
        border-radius: 10px;
      }

      img {
        width: 100%;
        height: 100%;
        position: relative;
        object-fit: cover;
        z-index: 1;
      }
    }

    &-text {
      display: flex;
      flex-direction: column;
      padding: 30px;
      gap: 20px;
      height: calc(50% - 70px);

      @media (max-width: 768px) {
        padding: 10px 15px;
        gap: 10px;
        height: calc(70% - 70px);
      }

      h5 {
        font-weight: 600;
        font-size: 28px;
        line-height: 120%;
        color: #000;

        @media (max-width: 768px) {
          font-size: 16px;
        }
      }

      p {
        font-weight: 500;
        font-size: 20px;
        line-height: 115%;
        color: #000000;

        @media (max-width: 768px) {
          font-size: 14px;
        }
      }
    }
  }

  .btn-wrapper {
    max-width: 1190px;
    margin: 50px auto 0;
  }
`;
